import React  , { Component } from 'react'

import { HomeSlider, HomeTitle , FaqItem } from '../../Components/UI/UI'

import { getWeather, asyncgetWeather } from "../../Utility/Utility";
import {  faqData } from "../../Data/Data";
import Menu from '../../Components/Menu/Menu'
import Footer from '../../Components/Footer/Footer'



class FAQ extends Component {

  state = {
    faq : faqData, 
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,

  }

  setCurrentFaq = (id) => {
    const faq = [...this.state.faq];
    const current = faq.find( (o)=>{
      return o.id === id;
    });
    if ( current.isOpen=== true ) {
      current.isOpen = false;
    } else {
      current.isOpen = true;
    }
    this.setState({
      faq : faq
    })

  }

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}
  
  render(){

     const faqHtml= this.state.faq.map((o)=>{
    
      return <FaqItem q={o.q} answer={o.answer} isOpen={o.isOpen} click={ () => {
        this.setCurrentFaq(o.id);
      }} />

    });
    return(
      <div className="page align-center page-FAQ inner-page">
        <Menu />
        <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
        <div class="container">
           <HomeTitle>
            أسئلة شائعة
            </HomeTitle>
            <div className="clear"></div>
            
            <div className="faq-wrapper">
                {faqHtml}
            </div>
            <div className="clear"></div>
        </div>
        <Footer />
      </div>
    )
  }

}



export default FAQ


// WEBPACK FOOTER //
// ./src/Pages/FAQ/FAQ.js